<template>
  <div
      class="call_area fullscreen_wrapper"
      ref="tile"
      :style="{
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      background: isCameraOn ? '' : '#000',
    }"
      :class="{ order_1: is_maximized, fullscreened: fullscreen }"
  >
    <div class="call_avatar" v-if="picture || user.picture">
      <!--      <img
              @load="imageLoaded"
              @error="reloadImage"
              ref="picture"
              :src="picture"
              v-if="picture"
            />

            <img
              :src="user.picture"
              alt=""
              v-else-if="user.picture && participant.isLocal"
            />-->

      <h3>{{ user.email.substring(0, 2) }}</h3>
    </div>

    <VideoTrack
        v-if="isCameraOn"
        v-bind:track="videoTrack"
        v-bind:isMediaStream="preview && previewTrack != null"
    />

    <AudioTrack
        v-if="isMicOn && !participant.isLocal"
        v-bind:track="participant.audio.track"
        :volume="volume"
    />

    <TileOptionDropDown
        :participant="participant"
        @maiximazeThis="is_maximized = true"
        @minimizeThis="is_maximized = false"
        @goFullscreen="togglefullscreen(), toggleApi()"
        @VolumeChange="volumeChangeGet"
        v-if="localParticipant.owner && !participant.isLocal"
    ></TileOptionDropDown>

    <div
        class="caption"
        v-if="showCaptions && meetingState == 'joined-meeting'"
    >
      {{ caption }}
    </div>

    <div class="name_notifiacation">
      <div class="muted" v-if="participant.audio.state === 'off'">
        <img src="@/assets/img/muted_icon.svg" alt=""/>
      </div>

      <div class="name">
        {{ participant.name }} {{ participant.isLocal ? "(you)" : "" }}
      </div>

      <div class="recording_notification" v-if="isRecording">Recording...</div>
    </div>

    <div class="emojo_wrap" v-if="reaction">
      <img :src="reaction" :class="{ fadeInUp: fade_in_emojo }" alt=""/>
    </div>
  </div>
</template>

<script>
import VideoTrack from "@/components/VideoTrack";
import AudioTrack from "@/components/AudioTrack";
import TileOptionDropDown from "@/components/TileOptionDropDown.vue";

export default {
  name: "Tile",
  data() {
    return {
      previewTrack: null,
      reloadErrorCount: 0,
      is_maximized: false,
      fullscreen: false,
      teleport: true,
      volume: 0.5,
      reaction: null,
      fade_in_emojo: false,
      users: 1,
    };
  },

  watch: {
    previewWhileCameraOff(stream, oldVal) {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        this.previewTrack = null;
      }
    },

    async localParticipant(newVal, oldVal) {
      if (this.preview && this.localParticipant.video) {
        let inputDevices = await this.$store.dispatch("getInputDevices");
        navigator.getUserMedia(
            {video: {deviceId: inputDevices.camera.deviceId}},
            (result) => {
              this.previewTrack = result;
            },
            (error) => {
              console.error(error);
            }
        );
      }
    },
  },

  methods: {
    resizeEvent() {
      this.calcBounds();
    },

    calcBounds() {
      /*console.log("calcBounds");
      this.$store.commit("setTileHeigth", "");
      this.$store.commit("setTileWidth", "");

      this.$nextTick(() => {
        this.tileWidthCalc();
        this.tileHeigthCalc();
      });
    },

    tileHeigthCalc() {
      this.$store.commit(
        "setTileHeigth",
        Math.floor((this.$refs.tile.clientWidth / 4) * 3) + "px"
      );*/
    },

    tileWidthCalc() {
      this.$store.commit(
          "setTileWidth",
          Math.floor((this.$refs.tile.clientHeight / 3) * 4) + "px"
      );
    },

    imageLoaded() {
      console.log("image loaded");
      this.$refs.picture.classList.remove("loading");
    },

    reloadImage() {
      this.$refs.picture.classList.add("loading");
      if (this.reloadErrorCount === 3) return;
      console.log("Trying to reload image");
      this.reloadErrorCount += 1;
      this.$nextTick(() => {
        setTimeout(
            () => (this.$refs.picture.src += `?timestamp=${Date.now()}`),
            1000 * this.reloadErrorCount
        );
      });
    },

    volumeChangeGet(VolumeChange) {
      this.volume = VolumeChange;
    },

    togglefullscreen() {
      this.fullscreen = !this.fullscreen;
    },

    toggleApi() {
      this.$fullscreen.toggle(this.$el.querySelector(".fullscreen_wrapper"), {
        teleport: this.teleport,
        callback: (isFullscreen) => {
          this.fullscreen = isFullscreen;
        },
      });
    },
  },

  components: {AudioTrack, VideoTrack, TileOptionDropDown},

  props: ["participant", "preview"],

  computed: {
    usersCounter() {
      this.users = this.$store.state.meeting.participants.length;
    },

    previewWhileCameraOff() {
      return !this.isCameraOn && this.previewTrack ? this.previewTrack : null;
    },

    videoTrack() {
      return this.preview ? this.previewTrack : this.participant.video.track;
    },

    roomData() {
      return this.$store.state.meeting.roomData;
    },

    picture() {
      if (this.participant.isLocal) {
        if (this.user) {
          return this.user.picture;
        } else {
          return `${
              process.env.VUE_APP_BACKEND_API_URL
          }/api/public/image/placeholder?name=${encodeURIComponent(
              this.participant.name
          )}`;
        }
      } else {
        return `${process.env.VUE_APP_BACKEND_API_URL}/api/public/rooms/${this.roomData._id}/meetings/${this.roomData.dailyRoomName}/participants/${this.participant.userId}/profile-picture`;
      }
    },

    meetingState() {
      return this.$store.state.meeting.currentState;
    },

    caption() {
      return this.$store.state.meeting.captions[this.participant.userId];
    },

    isCameraOn() {
      return (
          (this.preview &&
              !this.participant.video.off &&
              this.previewTrack != null) ||
          this.participant.video.track != null
      );
    },

    isMicOn() {
      return this.participant.audio.track != null;
    },

    user() {
      return this.$store.state.user;
    },

    localParticipant() {
      return this.$store.getters.localParticipant;
    },

    showCaptions() {
      return this.$store.state.meeting.showCaptions ?? false //TODO;
    },

    isRecording() {
      return this.$store.state.meeting.isRecording;
    },
  },

  async created() {
    window.addEventListener("resize", this.resizeEvent);

    await this.$store.dispatch("initMeetingState");
    this.$store.subscribe(async (mutation) => {
      if (mutation.type === "reaction") {
        if (mutation.payload.from === this.participant.userId) {
          this.fade_in_emojo = false;
          this.reaction = mutation.payload.svg;
          this.fade_in_emojo = true;
        }

        setTimeout(() => {
          this.fade_in_emojo = false;
          this.reaction = null;
        }, 1000);
      }
    });
  },
};
</script>

<style scoped lang="scss">
.emojo_wrap {
  position: absolute;
  pointer-events: none;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    height: 70%;
    opacity: 0;

    &.fadeInUp {
      animation-name: fadeInUpAndFadeOut;
      animation-duration: 1s;
      animation-fill-mode: both;
    }

    @keyframes fadeInUpAndFadeOut {
      0% {
        opacity: 0;
        transform: translate3d(0, 100%, 0);
      }
      50% {
        opacity: 1;
        transform: none;
      }

      100% {
        opacity: 0;
        transform: none;
      }
    }
  }
}

.name_notifiacation {
  display: flex;
  align-items: center;
  position: absolute;
  left: 16px;
  bottom: 16px;

  .muted {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background-color: #fc5a12;

    img {
      width: 16px;
      height: 16px;
    }
  }

  @media all and (max-width: 767px) {
    left: 8px;
    bottom: 8px;
    max-width: calc(100% - 16px);
  }

  .name {
    position: relative;
    left: 0;
    bottom: 0;
    white-space: nowrap;

    @media all and (max-width: 767px) {
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.recording_notification {
  margin-left: 16px;
  border-radius: 8px;
  background-color: #fc5a12;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  color: #fffeff;
  font-family: "Nunito Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  &:before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: #fff;
    flex: none;
    margin-right: 8px;
  }
}

.call_area_wrap {
  &.screencast {
    .order_1 {
      order: 1;
      height: auto !important;
      height: 80vh !important;
    }
  }
}

.call_avatar {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    min-height: 100%;
    min-width: 100%;
    object-position: center;
    object-fit: cover;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    &.loading {
      display: none;
    }
  }

  h3 {
    color: #000;
    font-family: "Playfair Display", serif;
    font-weight: 400;
    line-height: 32px;
    text-transform: uppercase;
  }
}

.caption {
  border-radius: 16px;
  background-color: #000;
  position: absolute;
  z-index: 3;
  left: 32px;
  bottom: 32px;
  right: 32px;
  text-align: center;
  padding: 20px;
  color: #fff;
  font-family: "Nunito Sans - Bold";
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}
</style>
